/**
 * Services Index
 * Central export point for all service modules
 */

// Import service instances for factory
import { apiService } from "./api.js";
import { templateService } from "./templateService.js";
import { checklistService } from "./checklistService.js";

// Base API service
export { apiService, ApiService, ApiError, API_CONFIG } from "./api.js";

// Template service
export { templateService, TemplateService } from "./templateService.js";

// Checklist service
export { checklistService, ChecklistService } from "./checklistService.js";

// Default exports for convenience
export { default as api } from "./api.js";
export { default as templates } from "./templateService.js";
export { default as checklists } from "./checklistService.js";

/**
 * Service registry for easy access to all services
 */
export const services = {
  api: () => import("./api.js").then((module) => module.apiService),
  templates: () =>
    import("./templateService.js").then((module) => module.templateService),
  checklists: () =>
    import("./checklistService.js").then((module) => module.checklistService),
};

/**
 * Service factory for creating service instances
 */
export const createServices = () => ({
  api: apiService,
  templates: templateService,
  checklists: checklistService,
});

// Re-export commonly used utilities
export { API_CONFIG as config } from "./api.js";
